import { ICintorinConfig } from "./common/interfaces";

declare const CintorinConfig: ICintorinConfig;

document.addEventListener("readystatechange", () => {
    if (document.readyState === 'complete') {
        document.querySelectorAll(".pamatniky a[data-monument-id]").forEach(a => a.addEventListener("click", showMonument));
        document.querySelectorAll(".pamatniky a[data-symbolic-cid]").forEach(a => a.addEventListener("click", showSymbolicCemetery));
        document.getElementById("symbolicke")?.addEventListener("click", switchCemeteryType);
        document.getElementById("1vojna")?.addEventListener("click", switchCemeteryType);
        document.getElementById("2vojna")?.addEventListener("click", switchCemeteryType);
    }
});

function switchCemeteryType() {
    let typ = "";
    if ((document.getElementById("symbolicke") as HTMLInputElement).checked) {
        typ += "1";
    }
    if ((document.getElementById("1vojna") as HTMLInputElement).checked) {
        typ += "2";
    }
    if ((document.getElementById("2vojna") as HTMLInputElement).checked) {
        typ += "3";
    }
    if (typ == "") {
        window.location.href='index.php?prve=1';
    } else {
        let href = 'index.php?cintoriny_typ='+typ;
        let citySearch = document.getElementById("citySearch") as HTMLInputElement;
        if (citySearch && citySearch.value) {
            href += "&citySearch="+citySearch.value;
        }
        let currentParams = new URLSearchParams(window.location.search);
        if (currentParams.get("search") == "pamatnik") {
            href += "&search=pamatnik";
        }
        window.location.href = href;
    }
}

function showMonument() {
    let id = this.getAttribute("data-monument-id");
    getUiChunk("../api/htmlGetMonumentPeople.php", "div_pamatnik", "mId="+id+"&lan="+CintorinConfig.language);
    getUiChunk("../api/htmlGetMonumentPhotos.php", "lavyobsah", "mId="+id+"&lan="+CintorinConfig.language);
}

function showSymbolicCemetery() {
    let id = this.getAttribute("data-symbolic-cid");
    getUiChunk("../api/htmlGetMonumentPeople.php", "div_pamatnik", "cId="+id+"&lan="+CintorinConfig.language).then(() => {
        document.querySelectorAll(".pamatniky_zosnuli a[data-symbolic-person]").forEach(a => a.addEventListener("click", showPersonSymbolicCemetery));
    });
}

function showPersonSymbolicCemetery() {
    let id = this.getAttribute("data-symbolic-person");
    getUiChunk("../api/htmlGetMonumentPhotos.php", "lavyobsah", "mId="+id+"&lan="+CintorinConfig.language);
}

function getUiChunk(url:string, id:string, payload:string) {
    let request:RequestInit = {
        method: "POST",
        headers: new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        }),
        body: payload
    };
    return fetch(url, request)
    .then(response => {
        if (response.ok && response.status == 200) {
            return response.text();
        }
    }).then(content => {
        if (content) {
            document.getElementById(id).innerHTML = content;
            if (document.getElementById("simpleSearchTitle")) {
                document.getElementById("simpleSearchTitle").classList.remove("karta-collapsed");
            }
        }
    });
}